import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Vale from './Vales';
import { ValesData } from '../../types/Types';
import { useValesMasivosContext } from './context/ValesMasivos.context';

interface Props {
  valesAct: ValesData[];
  retrieveValesAhorro: any;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setPromocion: React.Dispatch<React.SetStateAction<boolean>>;
  isMobile: boolean;
}

const ValesActivados: FC<Props> = ({
  valesAct,
  retrieveValesAhorro,
  isMobile,
  setVisible,
  setPromocion,
}) => {
  const { t, i18n } = useTranslation();
  const idiomaActual = i18n.language;
  const { cuponesMasivosActivados, formaterFecha } = useValesMasivosContext();
  const mostrarSeccion = () => {
    return valesAct?.length > 0 || cuponesMasivosActivados?.length > 0;
  };
  return mostrarSeccion() ? (
    <>
      <div className="divider" />
      <h2 className="bloque-datos__title u-text-brand">
        <span className="divider__square brand-color" />
        <span className="u-margin-right">{t('vales.activados')}</span>
      </h2>

      {cuponesMasivosActivados.map(
        (cuponesMasivosActivadoSegmentado, index) => {
          return (
            <div
              className="listado-vales listado-vales__activos listado-vales--masivos"
              id={`lista-vales-masivos-${index}`}
            >
              <div className="listado-vales__header">
                <h3 className="listado-vales__header-title">{`${cuponesMasivosActivadoSegmentado[0].textoTitulo}`}</h3>
                <p>{`Compra realizada el ${formaterFecha(
                  cuponesMasivosActivadoSegmentado[0]
                    .fechaEmisionValeDigitalizado,
                  idiomaActual,
                )}`}</p>
              </div>
              <div
                className="listado-vales__list"
                id={`lista-vales_list-${index}`}
              >
                {cuponesMasivosActivadoSegmentado.map((valeData) => (
                  <Vale
                    preActivado={false}
                    key={`vale-${valeData.valeEAN}`}
                    data={{
                      ...valeData,
                      masivo: true,
                      tipoLista: 6,
                      grupoIndex: index,
                    }}
                    cargarVales={retrieveValesAhorro}
                    valeIndex={isMobile ? 0 : index}
                    showCondLegales={setVisible}
                    setPromocion={setPromocion}
                  />
                ))}
              </div>
            </div>
          );
        },
      )}
      <div className="listado-vales listado-vales__activos">
        {valesAct?.map((valeData, index) => (
          <Vale
            setPromocion={setPromocion}
            key={`vale-${valeData.valeEAN}`}
            data={valeData}
            cargarVales={retrieveValesAhorro}
            valeIndex={isMobile ? 0 : index}
            showCondLegales={setVisible}
            preActivado={false}
          />
        ))}
      </div>
    </>
  ) : null;
};

export default ValesActivados;
